"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountHolderInfoCms = void 0;
var AccountHolderInfoCms = /** @class */ (function () {
    function AccountHolderInfoCms() {
        this.accountHolderTitleLabel = 'Account holder info';
        this.editCTALabel = 'Edit';
    }
    return AccountHolderInfoCms;
}());
exports.AccountHolderInfoCms = AccountHolderInfoCms;
//# sourceMappingURL=AccountHolderInfo.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/DeviceOptionsPanel/DeviceCard/AccountHolderInfo/AccountHolderInfo.cms.js
// module id = 2005
// module chunks = 8